import axios from "axios";

const API = axios.create({
  // baseURL: "http://localhost:5007/api",
  baseURL:"https://royalking2.com:5007/api"

});

// Add interceptor to automatically add token to all requests
API.interceptors.request.use(
  (config) => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      // Check if token exists in the response
      const token = userData.token || userData.user?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const errorMessage = error.response?.data?.error;
      if (errorMessage?.includes("Session expired") || errorMessage?.includes("Logged in from another device")) {
        // Clear local storage and redirect to login
        // localStorage.removeItem("user");
            alert("Logged in other device"); // ← add this temporarily

        // window.location.href = "/";
        
      }
    }
    return Promise.reject(error);
  }
);

export default API;